// extracted by mini-css-extract-plugin
module.exports = {"baggageBanner":"baggageBanner-Yq72K","image":"image-1QRxB"};